import MedicareBookOfBusiness from "pages/medicareBookOfBusiness/MedicareBookOfBusiness";
import React from "react";

export const MedicareCommission = () => {
    return (
        <MedicareBookOfBusiness />
    )
}

export default MedicareCommission;